import styled from "styled-components";

import { TextInputWrapperStyledProps as Props } from "./TextInputWrapper.types";

const TextInputWrapperStyled = styled.div<Props>`
  position: relative;

  .TextInputWrapper {
    &__input-spinner {
      position: absolute;
      right: 1.6rem;
      top: 6.4rem;
      animation: spinner 2s infinite linear;
    }
  }

  @keyframes spinner {
    from {
      rotate: 0deg;
    }
    to {
      rotate: 359deg;
    }
  }
`;

export default TextInputWrapperStyled;
